import { render } from "./AdDocViewTransactionsEmpty.vue?vue&type=template&id=16ae8cfc&ts=true"
import script from "./AdDocViewTransactionsEmpty.vue?vue&type=script&lang=ts"
export * from "./AdDocViewTransactionsEmpty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__